export default __webpack_public_path__ + "static/media/client15.f589f001.jpeg";